import { useEffect, useState } from "react";

import Image from "next/legacy/image";
import { blurDataURL } from "../../../utils/constants/images";
import { FixtureHighlightsTextButton } from "../../common/buttons/MatchHighlightsButton";
import { FixtureReviewTextButton } from "../../common/buttons/MatchReviewButton";
import {
  convertTo24HrTime,
  convertToShortDate,
} from "../../../utils/helpers/dateAndTime";
import { LIVE_MATCH_URL } from "../../../utils/constants/websiteUrls";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const FixtureResultCard = ({ result }) => {
  const [fixtureTime, setFixtureTime] = useState("");
  const [fixtureDate, setFixtureDate] = useState("");

  useEffect(() => {
    setFixtureTime(convertTo24HrTime(result.date_and_time));
    setFixtureDate(convertToShortDate(result.date_and_time));
  }, [result.date_and_time]);
  return (
    <>
      <div className="sm:px-10 mx-2 sm:mx-4 lg:mx-auto lg:max-w-4xl xl:max-w-6xl 2xl:max-w-[1220px] rounded-md border-2 border-red-600 dark:border-green-800 space-y-4 py-4 sm:py-6">
        <div className="flex flex-col justify-center items-center text-center">
          <div className="text-xs text-gray-400">{result.competition}</div>
          <div className="text-xs text-gray-400">
            {result.week_or_round_number}
          </div>
        </div>
        <div className="flex flex-col justify-center items-center sm:flex-row sm:justify-between sm:items-center">
          <div className="flex justify-center items-center space-x-4">
            <div className="hidden sm:block divide-y-2 divide-red-600">
              <Image
                src={result.competition_logo}
                alt="Competition Logo"
                width="35px"
                height="35px"
                quality={100}
                priority
              />
            </div>
            <span
              className="h-14 w-px ml-4 mr-4 bg-red-600 dark:bg-green-800 hidden sm:block"
              aria-hidden="true"
            ></span>
            <div>
              <Image
                src={
                  result.home_team === "Kotoko" ||
                  result.home_team === "Asante Kotoko"
                    ? result.away_team_logo
                    : result.home_team_logo
                }
                alt="Team Logo"
                width="100px"
                height="100px"
                quality={100}
                priority
                placeholder="blur"
                blurDataURL={blurDataURL}
              />
            </div>
            <div className="flex flex-col justify-center items-start">
              <div className="space-y-3 pb-4">
                <p className=" divide-x-2 w-40 sm:w-64 whitespace-nowrap truncate">
                  <span className="font-extrabold pr-2">
                    {result.home_team_score}
                  </span>
                  <span
                    className={classNames(
                      result.home_team === "Asante Kotoko" ||
                        result.home_team === "Kotoko"
                        ? "font-bold"
                        : "font-normal",
                      "pl-2 "
                    )}
                  >
                    {result.home_team}
                  </span>
                </p>
                <p className=" divide-x-2 w-40 sm:w-64 whitespace-nowrap truncate">
                  <span className="font-extrabold  pr-2">
                    {result.away_team_score}
                  </span>

                  <span
                    className={classNames(
                      result.away_team === "Asante Kotoko" ||
                        result.away_team === "Kotoko"
                        ? "font-bold"
                        : "font-normal",
                      "pl-2"
                    )}
                  >
                    {result.away_team}
                  </span>
                </p>
              </div>

              <div className="text-xs">
                <span className="font-bold">{`${fixtureTime}, `}</span>
                <span className="font-normal text-gray-400">{fixtureDate}</span>
              </div>
            </div>
          </div>

          <div>
            {result.is_live_match_created && (
              <FixtureReviewTextButton
                matchReportUrl={`${LIVE_MATCH_URL}/${result.slug}`}
              />
            )}

            {result.highlight_url && (
              <FixtureHighlightsTextButton
                highlightUrl={result.highlight_url}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FixtureResultCard;
